import {
	Box,
	Button,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Divider,
	TextField,
	Typography,
	Badge,
	CircularProgress,
} from "@mui/material";
import { KeyboardArrowRight as KeyboardArrowRightIcon } from "@mui/icons-material";
import React, { useState, useEffect } from "react";
import useAuth from "../../../../hooks/useAuth";
import axios from "../../../../api/axios";
import useAxiosPrivate from "../../../../hooks/useAxiosPrivate";

export default function FreshModal(props) {
	const { plan, minAmount, maxAmount, roi, planId, botName } = props;
	const { auth } = useAuth();
	const axiosPrivate = useAxiosPrivate();
	// Modal open state
	const [open, setOpen] = useState(false);

	// Form fields
	const [amount, setAmount] = useState("");
	const [walletAddress, setWalletAddress] = useState("");
	const [walletName, setWalletName] = useState("");
	const [isPlan1Active, setIsPlan1Active] = useState(false);
	const [isPlan2Active, setIsPlan2Active] = useState(false);
	const [isPlan3Active, setIsPlan3Active] = useState(false);
	const [isPlan4Active, setIsPlan4Active] = useState(false);
	const [isPlan5Active, setIsPlan5Active] = useState(false);
	const [isPlan6Active, setIsPlan6Active] = useState(false);
	const [isPlan7Active, setIsPlan7Active] = useState(false);

	// Feedback messages
	const [dialogFeedback, setDialogFeedback] = useState({
		message: "",
		severity: "",
	});
	const [feedback, setFeedback] = useState({
		open: false,
		message: "",
		severity: "",
	});

	// Investment plan state
	const [isActive, setIsActive] = useState(false);
	const [loading, setLoading] = useState(false);

	// Fetch plan status on mount
	useEffect(() => {
		const fetchStatus = async () => {
			try {
				setLoading(true);
				const response = await axiosPrivate.get(`/singleuser/${auth?.id}`);
				console.log(response.data?.foundUser);
				// setIsActive(response.data?.active === true);

				if (response.data.foundUser.isPlan1Active && planId === 1) {
					setIsPlan1Active(true);
				}

				if (response.data.foundUser.isPlan2Active && planId === 2) {
					setIsPlan2Active(true);
				}

				if (response.data.foundUser.isPlan3Active && planId === 3) {
					setIsPlan3Active(true);
				}

				if (response.data.foundUser.isPlan4Active && planId === 4) {
					setIsPlan4Active(true);
				}

				if (response.data.foundUser.isPlan5Active && planId === 5) {
					setIsPlan5Active(true);
				}

				if (response.data.foundUser.isPlan6Active && planId === 6) {
					setIsPlan6Active(true);
				}

				if (response.data.foundUser.isPlan7Active && planId === 7) {
					setIsPlan7Active(true);
				}
			} catch (error) {
				console.error("Error fetching plan status:", error);
			} finally {
				setLoading(false);
			}
		};
		fetchStatus();
	}, []);

	const handleOpen = () => setOpen(true);
	const handleClose = () => {
		setOpen(false);
		setDialogFeedback({ message: "", severity: "" });
	};

	const handleAmountChange = (e) => setAmount(e.target.value);
	const handleWalletAddressChange = (e) => setWalletAddress(e.target.value);
	const handleWalletNameChange = (e) => setWalletName(e.target.value);

	const handleSubmit = async () => {
		setDialogFeedback({ message: "", severity: "" });
		const payload = {
			id: auth?.id,
			amount: parseFloat(amount),
			plan,
			roi,
			minAmount,
			maxAmount,
			walletAddress,
			walletName,
			botName,
			action: "activate",
		};
		try {
			const response = await axios.patch("/plan-selector", payload);
			if (response.status === 200) {
				setFeedback({
					open: true,
					message: "Plan activated!",
					severity: "success",
				});
				handleClose();
				setIsActive(true);

				if (botName.includes("1") && planId === 1) {
					setIsPlan1Active(true);
				}

				if (botName.includes("2") && planId === 2) {
					setIsPlan2Active(true);
				}

				if (botName.includes("3") && planId === 3) {
					setIsPlan3Active(true);
				}

				if (botName.includes("4") && planId === 4) {
					setIsPlan4Active(true);
				}

				if (botName.includes("5") && planId === 5) {
					setIsPlan5Active(true);
				}

				if (botName.includes("6") && planId === 6) {
					setIsPlan6Active(true);
				}

				if (botName.includes("7") && planId === 7) {
					setIsPlan7Active(true);
				}
			} else {
				setDialogFeedback({
					message: response.data?.message || "Submission failed",
					severity: "error",
				});
			}
		} catch (error) {
			setDialogFeedback({
				message: error.response?.data?.message || "Network error",
				severity: "error",
			});
		}
	};

	const handleQuitPlan = async () => {
		if (!window.confirm("Are you sure you want to quit this plan?")) return;
		setLoading(true);
		const payload = {
			id: auth?.id,
			amount: parseFloat(amount),
			plan,
			roi,
			minAmount,
			maxAmount,
			walletAddress,
			walletName,
			botName,

			action: "deactivate",
		};
		try {
			const response = await axios.patch("/plan-selector", payload);
			if (response.status === 200) {
				setFeedback({
					open: true,
					message: "Plan canceled successfully",
					severity: "info",
				});
				// setIsActive(false);

				if (botName.includes("1") && planId === 1) {
					setIsPlan1Active(false);
				}

				if (botName.includes("2") && planId === 2) {
					setIsPlan2Active(false);
				}

				if (botName.includes("3") && planId === 3) {
					setIsPlan3Active(false);
				}

				if (botName.includes("4") && planId === 4) {
					setIsPlan4Active(false);
				}

				if (botName.includes("5") && planId === 5) {
					setIsPlan5Active(false);
				}

				if (botName.includes("6") && planId === 6) {
					setIsPlan6Active(false);
				}

				if (botName.includes("7") && planId === 7) {
					setIsPlan7Active(false);
				}
			}
		} catch (err) {
			console.error("Error quitting plan:", err);
		} finally {
			setLoading(false);
		}
	};

	console.log(
		isPlan1Active,
		isPlan2Active,
		isPlan3Active,
		isPlan4Active,
		isPlan5Active,
		isPlan6Active,
		isPlan7Active
	);

	return (
		<Box sx={{ maxWidth: 400, margin: "auto", p: 2, position: "relative" }}>
			{/* Show badge with green dot if active */}

			{isPlan1Active ? (
				<Badge
					overlap="circular"
					anchorOrigin={{ vertical: "top", horizontal: "right" }}
					badgeContent={
						<Box
							sx={{
								width: 12,
								height: 12,
								bgcolor: "green",
								borderRadius: "50%",
								boxShadow: 1,
							}}
						/>
					}>
					<Button
						variant="contained"
						fullWidth
						onClick={handleOpen}
						sx={{ fontSize: "0.8rem", bgcolor: "green", color: "white" }}>
						Top up <KeyboardArrowRightIcon sx={{ ml: 0.4 }} />
					</Button>
				</Badge>
			) : isPlan2Active ? (
				<Badge
					overlap="circular"
					anchorOrigin={{ vertical: "top", horizontal: "right" }}
					badgeContent={
						<Box
							sx={{
								width: 12,
								height: 12,
								bgcolor: "green",
								borderRadius: "50%",
								boxShadow: 1,
							}}
						/>
					}>
					<Button
						variant="contained"
						color="primary"
						fullWidth
						onClick={handleOpen}
						sx={{ fontSize: "0.8rem" }}>
						Top up <KeyboardArrowRightIcon sx={{ ml: 0.4 }} />
					</Button>
				</Badge>
			) : isPlan3Active ? (
				<Badge
					overlap="circular"
					anchorOrigin={{ vertical: "top", horizontal: "right" }}
					badgeContent={
						<Box
							sx={{
								width: 12,
								height: 12,
								bgcolor: "green",
								borderRadius: "50%",
								boxShadow: 1,
							}}
						/>
					}>
					<Button
						variant="contained"
						color="primary"
						fullWidth
						onClick={handleOpen}
						sx={{ fontSize: "0.8rem" }}>
						Top up <KeyboardArrowRightIcon sx={{ ml: 0.4 }} />
					</Button>
				</Badge>
			) : isPlan4Active ? (
				<Badge
					overlap="circular"
					anchorOrigin={{ vertical: "top", horizontal: "right" }}
					badgeContent={
						<Box
							sx={{
								width: 12,
								height: 12,
								bgcolor: "green",
								borderRadius: "50%",
								boxShadow: 1,
							}}
						/>
					}>
					<Button
						variant="contained"
						color="primary"
						fullWidth
						onClick={handleOpen}
						sx={{ fontSize: "0.8rem" }}>
						Top up <KeyboardArrowRightIcon sx={{ ml: 0.4 }} />
					</Button>
				</Badge>
			) : isPlan5Active ? (
				<Badge
					overlap="circular"
					anchorOrigin={{ vertical: "top", horizontal: "right" }}
					badgeContent={
						<Box
							sx={{
								width: 12,
								height: 12,
								bgcolor: "green",
								borderRadius: "50%",
								boxShadow: 1,
							}}
						/>
					}>
					<Button
						variant="contained"
						color="primary"
						fullWidth
						onClick={handleOpen}
						sx={{ fontSize: "0.8rem" }}>
						Top up <KeyboardArrowRightIcon sx={{ ml: 0.4 }} />
					</Button>
				</Badge>
			) : isPlan6Active ? (
				<Badge
					overlap="circular"
					anchorOrigin={{ vertical: "top", horizontal: "right" }}
					badgeContent={
						<Box
							sx={{
								width: 12,
								height: 12,
								bgcolor: "green",
								borderRadius: "50%",
								boxShadow: 1,
							}}
						/>
					}>
					<Button
						variant="contained"
						color="primary"
						fullWidth
						onClick={handleOpen}
						sx={{ fontSize: "0.8rem" }}>
						Top up <KeyboardArrowRightIcon sx={{ ml: 0.4 }} />
					</Button>
				</Badge>
			) : isPlan7Active ? (
				<Badge
					overlap="circular"
					anchorOrigin={{ vertical: "top", horizontal: "right" }}
					badgeContent={
						<Box
							sx={{
								width: 12,
								height: 12,
								bgcolor: "green",
								borderRadius: "50%",
								boxShadow: 1,
							}}
						/>
					}>
					<Button
						variant="contained"
						color="primary"
						fullWidth
						onClick={handleOpen}
						sx={{ fontSize: "0.8rem" }}>
						Top up <KeyboardArrowRightIcon sx={{ ml: 0.4 }} />
					</Button>
				</Badge>
			) : (
				<Button
					variant="contained"
					color="primary"
					fullWidth
					onClick={handleOpen}
					sx={{ fontSize: "0.7rem" }}>
					Choose Plan <KeyboardArrowRightIcon sx={{ ml: 0.4 }} />
				</Button>
			)}

			{/* Modal for plan */}
			<Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
				<DialogTitle>{plan}</DialogTitle>

				{/* Error message at the top */}
				{dialogFeedback.message && (
					<Typography
						sx={{
							color: dialogFeedback.severity === "error" ? "red" : "green",
							fontWeight: "bold",
							padding: "0.75rem 1rem",
							backgroundColor: "#fdd",
							borderRadius: "4px",
							margin: "0.5rem",
							textAlign: "center",
						}}>
						{dialogFeedback.message}
					</Typography>
				)}

				<Typography sx={{ color: "black", fontSize: "0.9rem", ml: "1.6rem" }}>
					<span style={{ color: "red" }}>ROI</span>: {roi}%
				</Typography>
				<Divider sx={{ my: "0.6rem", width: "100%" }} />
				<Typography sx={{ color: "gray", fontSize: "0.9rem", ml: "1.6rem" }}>
					<span style={{ color: "yellow" }}>Note:</span> Your investment will be
					traded based on ROI, which influences your daily returns.
				</Typography>
				<Typography sx={{ marginX: "auto", marginTop: "1rem" }}>
					Account Balance:{" "}
					<span
						style={{
							display: "inline-block",
							padding: "0.2rem 0.5rem",
							fontSize: "0.8rem",
							color: "gray",
							backgroundColor: "#eee",
							borderRadius: "4px",
						}}>
						${Number(auth?.balance).toFixed(2)}
					</span>
				</Typography>

				<DialogContent>
					<TextField
						label="Amount to Invest"
						type="number"
						fullWidth
						margin="normal"
						value={amount}
						onChange={handleAmountChange}
					/>
					<Typography sx={{ color: "gray", fontSize: "0.9rem" }}>
						${minAmount} - ${maxAmount}
					</Typography>
				</DialogContent>

				{/* Action buttons */}
				<DialogActions>
					<Button onClick={handleClose}>Cancel</Button>
					<Button variant="contained" color="primary" onClick={handleSubmit}>
						Submit
					</Button>
				</DialogActions>
			</Dialog>

			{/* Show "Quit Plan" button if active */}
			{isPlan1Active && (
				<Button
					variant="outlined"
					color="error"
					fullWidth
					onClick={handleQuitPlan}
					disabled={loading}
					sx={{ mt: 2 }}>
					{loading ? <CircularProgress size={20} /> : "Quit Plan"}
				</Button>
			)}

			{isPlan2Active && (
				<Button
					variant="outlined"
					color="error"
					fullWidth
					onClick={handleQuitPlan}
					disabled={loading}
					sx={{ mt: 2 }}>
					{loading ? <CircularProgress size={20} /> : "Quit Plan"}
				</Button>
			)}

			{isPlan3Active && (
				<Button
					variant="outlined"
					color="error"
					fullWidth
					onClick={handleQuitPlan}
					disabled={loading}
					sx={{ mt: 2 }}>
					{loading ? <CircularProgress size={20} /> : "Quit Plan"}
				</Button>
			)}

			{isPlan4Active && (
				<Button
					variant="outlined"
					color="error"
					fullWidth
					onClick={handleQuitPlan}
					disabled={loading}
					sx={{ mt: 2 }}>
					{loading ? <CircularProgress size={20} /> : "Quit Plan"}
				</Button>
			)}

			{isPlan5Active && (
				<Button
					variant="outlined"
					color="error"
					fullWidth
					onClick={handleQuitPlan}
					disabled={loading}
					sx={{ mt: 2 }}>
					{loading ? <CircularProgress size={20} /> : "Quit Plan"}
				</Button>
			)}

			{isPlan6Active && (
				<Button
					variant="outlined"
					color="error"
					fullWidth
					onClick={handleQuitPlan}
					disabled={loading}
					sx={{ mt: 2 }}>
					{loading ? <CircularProgress size={20} /> : "Quit Plan"}
				</Button>
			)}

			{isPlan7Active && (
				<Button
					variant="outlined"
					color="error"
					fullWidth
					onClick={handleQuitPlan}
					disabled={loading}
					sx={{ mt: 2 }}>
					{loading ? <CircularProgress size={20} /> : "Quit Plan"}
				</Button>
			)}

			{/* Feedback outside modal */}
			{feedback.open && (
				<Typography
					sx={{
						marginTop: 2,
						padding: 1,
						backgroundColor:
							feedback.severity === "success"
								? "green"
								: feedback.severity === "info"
									? "blue"
									: "red",
						color: "white",
						borderRadius: 1,
						maxWidth: 400,
						margin: "auto",
						textAlign: "center",
					}}>
					{feedback.message}
				</Typography>
			)}
		</Box>
	);
}
